var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    fill: "none",
    viewBox: "0 0 20 24",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.94 10.94a1.5 1.5 0 0 0 0 2.12l9.545 9.547a1.5 1.5 0 1 0 2.122-2.122L4.12 12l8.486-8.485a1.5 1.5 0 1 0-2.122-2.122L.94 10.94ZM20 10.5H2v3h18v-3Z"
  })));
};
export { SvgLeftArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuOTM5MzQgMTAuOTM5M0MwLjM1MzU1MyAxMS41MjUxIDAuMzUzNTUzIDEyLjQ3NDkgMC45MzkzNCAxMy4wNjA3TDEwLjQ4NTMgMjIuNjA2NkMxMS4wNzExIDIzLjE5MjQgMTIuMDIwOCAyMy4xOTI0IDEyLjYwNjYgMjIuNjA2NkMxMy4xOTI0IDIyLjAyMDggMTMuMTkyNCAyMS4wNzExIDEyLjYwNjYgMjAuNDg1M0w0LjEyMTMyIDEyTDEyLjYwNjYgMy41MTQ3MkMxMy4xOTI0IDIuOTI4OTMgMTMuMTkyNCAxLjk3OTE4IDEyLjYwNjYgMS4zOTM0QzEyLjAyMDggMC44MDc2MTIgMTEuMDcxMSAwLjgwNzYxMiAxMC40ODUzIDEuMzkzNEwwLjkzOTM0IDEwLjkzOTNaTTIwIDEwLjVMMiAxMC41VjEzLjVMMjAgMTMuNVYxMC41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";